import { useState } from "react";
import { Calendar } from "components/calendar";
import DraftTimesheetLogLayout from "../../layout";
import useMonthlyDraftTimesheet from "./useMonthlyTimesheet";
import TimesheetDayCell from "./_Cell";
import { TimesheetHeaderTitle } from "@/modules/timesheet/components/header";
import { TITLE } from "@/modules/timesheet/logs/views/calendar/constants";

export default function DraftTimesheetLogCalendar() {
  const [date, setDate] = useState(new Date());
  const { transformedData, isLoading } = useMonthlyDraftTimesheet(date);

  return (
    <DraftTimesheetLogLayout
      headerContent={<TimesheetHeaderTitle>{TITLE}</TimesheetHeaderTitle>}
    >
      <Calendar
        key={transformedData.id}
        date={date}
        setDate={setDate}
        events={transformedData}
        renderDay={TimesheetDayCell}
        isLoading={isLoading}
        isHeaderPortal={true}
      />
    </DraftTimesheetLogLayout>
  );
}
